'use strict';

import axios from 'axios';
import { prepend } from '@jspartials/dom-api-utils';

// Variables
const TOAST_TYPE_NOTIFICATION = 'toast';
const TOAST_TYPE_SUCCESS = 'success';
const TOAST_TYPE_ERROR = 'error';
const urlGetToastNotification = globalVariables.endpoint.toastNotification;
const keyTexts = {
  page: {
    profile: {
      message: {
        updated: {
          success: 'profile_updated_successfully'
        }
      }
    },
    addresses: {
      message: {
        deleted: {
          success: 'address_deleted_successfully'
        }
      }
    },
    paymentInstruments: {
      message: {
        deleted: {
          success: 'payment_instrument_removed_successfully'
        },
        cannotDelete: {
          paymentInstrumentUsedInSubscription:
            'payment_instrument_used_in_subscription'
        }
      }
    },
    contactLensesSubscriptions: {
      list: {
        message: {
          reactivated: {
            error: 'subscription_reactivated'
          }
        }
      },
      paymentMethods: {
        message: {
          updated: {
            success: 'payment_method_updated_successfully',
            error: 'update_payment_method'
          }
        }
      },
      details: {
        message: {
          updated: {
            success: 'subscription_updated_successfully',
            error: 'update_subscription'
          }
        }
      }
    }
  }
};
const keyFiles = {
  message: 'message',
  error: 'error'
};

const showToastNotification = (
  container,
  { message = '', keyText = '', keyFile = '', type = TOAST_TYPE_ERROR } = {}
) => {
  const formData = new FormData();
  formData.append('message', message);
  formData.append('keyText', keyText);
  formData.append('keyFile', keyFile);
  formData.append('type', type);

  axios
    .post(urlGetToastNotification, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(function (response) {
      if (response.status === 200) {
        const responseData = response.data;
        const notification =
          'notification' in responseData ? responseData.notification : '';

        if (notification.length > 0) {
          printToastNotificationMessage(container, notification);
        }
      } else {
        console.warn('Response status is not 200');
      }
    })
    .catch(function (error) {
      console.error(error);
    });
};

const printToastNotificationMessage = (container, message) => {
  const notificationWrapper = document.createElement('div');
  notificationWrapper.innerHTML = message;
  prepend(container, notificationWrapper);
};

export {
  TOAST_TYPE_NOTIFICATION,
  TOAST_TYPE_SUCCESS,
  TOAST_TYPE_ERROR,
  keyTexts,
  keyFiles,
  showToastNotification
};
